var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTodoEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.875L5.89895 6.44715C6.29565 6.73641 6.49401 6.88105 6.70976 6.93707C6.90034 6.98655 7.09966 6.98655 7.29024 6.93707C7.50599 6.88105 7.70435 6.73641 8.10105 6.44715L13 2.875M3.88 11H10.12C11.1281 11 11.6321 11 12.0172 10.7956C12.3559 10.6159 12.6312 10.329 12.8038 9.97623C13 9.57515 13 9.0501 13 8V4C13 2.9499 13 2.42485 12.8038 2.02377C12.6312 1.67096 12.3559 1.38413 12.0172 1.20436C11.6321 1 11.1281 1 10.12 1H3.88C2.87191 1 2.36786 1 1.98282 1.20436C1.64413 1.38413 1.36876 1.67096 1.19619 2.02377C1 2.42485 1 2.9499 1 4V8C1 9.0501 1 9.57515 1.19619 9.97623C1.36876 10.329 1.64413 10.6159 1.98282 10.7956C2.36786 11 2.87191 11 3.88 11Z",
    stroke: "#6987B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTodoEmail);
export default __webpack_public_path__ + "static/media/DashboardTodoEmail.938ddfbd5a8b8532cfbd39f594d3731b.svg";
export { ForwardRef as ReactComponent };